import type { RouteRecordRaw } from 'vue-router'
import { $t } from '@/locales'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/fund_manage',
  component: Layout,
  redirect: '/fund_manage/recharge',
  name: 'FundManage',
  meta: {
    title: $t('route.fund_manage.title'),
    icon: 'fund_manage',
  },
  children: [
    {
      path: 'recharge',
      name: 'FundManageRecharge',
      component: () => import('@/views/fund_manage/recharge.vue'),
      meta: {
        title: $t('route.fund_manage.recharge'),
        icon: 'fund_manage_recharge',
      },
    },
    {
      path: 'details',
      name: 'FundManageDetails',
      component: () => import('@/views/fund_manage/details.vue'),
      meta: {
        title: $t('route.fund_manage.details'),
        icon: 'fund_manage_details',
      },
    },
  ],
}

export default routes
